module.exports = __webpack_public_path__ + "img/20200912_154939.12419eec.jpg";